import React, { FunctionComponent } from 'react'
import { Modal, Button, Container, Row, Col, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { formatUTCDate, formatDollar } from '../../../utils/stringTools'
import ClaimType from '../../../types/Claim'
import Provider from '../../../types/Provider'

import './index.css'

interface Props {
  show: boolean;
  org: string;
  provider: Provider;
  claim?: ClaimType;
  onClose: () => void;
}

const ClaimModal: FunctionComponent<Props> = (props) => {
  const { show, onClose, org, provider, claim } = props
  let exCode = claim ? claim.exCode : ''

  return (
    <Modal size="xl" show={show} onHide={onClose}>
      <Modal.Header closeButton id="modal-header">
        <FontAwesomeIcon icon={['fas', 'file-alt']} size="lg" className="modal-header-icon" />
        <Modal.Title id="modal-header-title">Claims Detail</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container>
          <Row id="claim-row">
            <Col id="left-col-row" xs={4}>
              <div className="left-col">
                                Organization
              </div>
            </Col>
            <Col xs={8} style={{ background: '#f5f5f5' }}>
              <div className="right-col">
                {
                  org
                }
              </div>
            </Col>
          </Row>
          <Row id="claim-row">
            <Col id="left-col-row" xs={4}>
              <div className="left-col">
                                Tax ID
              </div>
            </Col>
            <Col xs={8} style={{ background: '#f5f5f5' }}>
              <div className="right-col">
                {
                  provider.tax_id_number
                }
              </div>
            </Col>
          </Row>
          <Row id="claim-row">
            <Col id="left-col-row" xs={4}>
              <div className="left-col">
                                Facility
              </div>
            </Col>
            <Col xs={8} style={{ background: '#f5f5f5' }}>
              <div className="right-col">
                {
                  provider.provider_name
                }
              </div>
            </Col>
          </Row>
          <Row id="claim-row">
            <Col id="left-col-row" xs={4}>
              <div className="left-col">
                                Member ID
              </div>
            </Col>
            <Col xs={8} style={{ background: '#f5f5f5' }}>
              <div className="right-col" >
                {
                  claim ? claim.memberId : ''
                }
              </div>
            </Col>
          </Row>
          <Row id="claim-row">
            <Col id="left-col-row" xs={4}>
              <div className="left-col">
                                Last Name
              </div>
            </Col>
            <Col xs={8} style={{ background: '#f5f5f5' }}>
              <div className="right-col">
                {
                  claim ? claim.lastName : ''
                }
              </div>
            </Col>
          </Row>
          <Row id="claim-row">
            <Col id="left-col-row" xs={4}>
              <div className="left-col">
                                First Name
              </div>
            </Col>
            <Col xs={8} style={{ background: '#f5f5f5' }}>
              <div className="right-col">
                {
                  claim ? claim.firstName : ''
                }
              </div>
            </Col>
          </Row>
          <Row id="claim-row">
            <Col id="left-col-row" xs={4}>
              <div className="left-col">
                                Authorization No.
              </div>
            </Col>
            <Col xs={8} style={{ background: '#f5f5f5' }}>
              <div className="right-col">
                {
                  claim ? claim.authNumber : ''
                }
              </div>
            </Col>
          </Row>
          <Row id="claim-row">
            <Col id="left-col-row" xs={4}>
              <div className="left-col">
                                Denial Reason
              </div>
            </Col>
            <Col xs={8} style={{ background: '#f5f5f5', display: 'flex' }}>
              <div className="right-col">
                {
                  claim ? claim.exCode : ''
                }
              </div> 
              {
                exCode !== null ? (
                  <OverlayTrigger
                    placement='bottom'
                    overlay={
                      <Tooltip id={'tooltip-bottom'}>
                        {claim ? claim.denialReason : ''}
                      </Tooltip>
                    }
                  >
                    <FontAwesomeIcon icon={['fas', 'exclamation-circle']} color="#336699" style={{alignSelf: 'center', marginBottom: 3}} />
                  </OverlayTrigger>
                ) : (
                  <div></div>
                )
              }
            </Col>
          </Row>
          <Row id="claim-row">
            <Col id="left-col-row" xs={4}>
              <div className="left-col">
                                Service Type
              </div>
            </Col>
            <Col xs={8} style={{ background: '#f5f5f5' }}>
              <div className="right-col">
                {
                  claim ? claim.serviceType : ''
                }
              </div>
            </Col>
          </Row>
          <Row id="claim-row">
            <Col id="left-col-row" xs={4}>
              <div className="left-col">
                                Procedure Code
              </div>
            </Col>
            <Col xs={8} style={{ background: '#f5f5f5' }}>
              <div className="right-col">
                {
                  claim ? claim.proceduralCode : ''
                }
              </div>
            </Col>
          </Row>
          <Row id="claim-row">
            <Col id="left-col-row" xs={4}>
              <div className="left-col">
                                Procedure Description
              </div>
            </Col>
            <Col xs={8} style={{ background: '#f5f5f5' }}>
              <div className="right-col">
                {
                  claim ? claim.proceduralDescription : ''
                }
              </div>
            </Col>
          </Row>
          <Row id="claim-row">
            <Col id="left-col-row" xs={4}>
              <div className="left-col">
                               Units
              </div>
            </Col>
            <Col xs={8} style={{ background: '#f5f5f5' }}>
              <div className="right-col">
                {
                  claim ? claim.units : ''
                }
              </div>
            </Col>
          </Row>
          <Row id="claim-row">
            <Col id="left-col-row" xs={4}>
              <div className="left-col">
                              Date Received
              </div>
            </Col>
            <Col xs={8} style={{ background: '#f5f5f5' }}>
              <div className="right-col">
                {
                  claim ? formatUTCDate(claim.dateReceived) : ''
                }
              </div>
            </Col>
          </Row>
          <Row id="claim-row">
            <Col id="left-col-row" xs={4}>
              <div className="left-col">
                               Service From
              </div>
            </Col>
            <Col xs={8} style={{ background: '#f5f5f5' }}>
              <div className="right-col">
                {
                  claim ? formatUTCDate(claim.serviceFrom) : ''
                }
              </div>
            </Col>
          </Row>
          <Row id="claim-row">
            <Col id="left-col-row" xs={4}>
              <div className="left-col">
                               Service To
              </div>
            </Col>
            <Col xs={8} style={{ background: '#f5f5f5' }}>
              <div className="right-col">
                {
                  claim ? formatUTCDate(claim.serviceTo) : ''
                }
              </div>
            </Col>
          </Row>
          <Row id="claim-row">
            <Col id="left-col-row" xs={4}>
              <div className="left-col">
                               Claim No.
              </div>
            </Col>
            <Col xs={8} style={{ background: '#f5f5f5' }}>
              <div className="right-col">
                {
                  claim ? claim.claimNumber : ''
                }
              </div>
            </Col>
          </Row>
          <Row id="claim-row">
            <Col id="left-col-row" xs={4}>
              <div className="left-col">
                               Check No.
              </div>
            </Col>
            <Col xs={8} style={{ background: '#f5f5f5' }}>
              <div className="right-col">
                {
                  claim ? claim.checkNumber : ''
                }
              </div>
            </Col>
          </Row>
          <Row id="claim-row">
            <Col id="left-col-row" xs={4}>
              <div className="left-col">
                               Date Paid
              </div>
            </Col>
            <Col xs={8} style={{ background: '#f5f5f5' }}>
              <div className="right-col">
                {
                  claim ? formatUTCDate(claim.datePaid) : ''
                }
              </div>
            </Col>
          </Row>
          <Row id="claim-row">
            <Col id="left-col-row" xs={4}>
              <div className="left-col">
                               Amount Billed
              </div>
            </Col>
            <Col xs={8} style={{ background: '#f5f5f5' }}>
              <div className="right-col">
                {
                  claim ? formatDollar(claim.billedAmount) : ''
                }
              </div>
            </Col>
          </Row>
          <Row id="claim-row">
            <Col id="left-col-row" xs={4}>
              <div className="left-col">
                               Amount Paid
              </div>
            </Col>
            <Col xs={8} style={{ background: '#f5f5f5' }}>
              <div className="right-col">
                {
                  claim ? formatDollar(claim.amountPaid) : ''
                }
              </div>
            </Col>
          </Row>
          <Row>
            <Col xs={{ span: 3, offset: 5 }}>
              <Button variant="outline-secondary" block onClick={onClose} style={{ marginTop: 15 }}>
                                Close
              </Button>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
    </Modal>
  )
}

export default ClaimModal